import React, { useEffect, useState } from "react";
import styles from "./ekyc.module.scss";

const AuditLogs = ({ token }) => {
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
  }, []);
  return (
    <div className={styles.ekycWrapper}>
        <h5>Ekyc Audit Logs</h5>
    </div>
  );
};

export default AuditLogs;
